<input
  type="range"
  min="0"
  max="1"
  step="0.01"
  [value]="value"
  class="slider"
  #slider
  (change)="onSliderChange($event)"
/>
<p>{{ value | percent }}</p>
